// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__8JKkL","list":"styles_list__3g_zP"};